import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Variable match
 */

export default function PersonFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <g>
        <circle cx="8" cy="4" fill="#919191" r="4" />
        <path
          d="M14.9761 15.5004C15.0025 15.7753 14.7607 16 14.4846 16C2.81646 16 11.8113 16 8 16C4.2133 16 9.33708 16 1.50897 16C1.23283 16 0.997487 15.7753 1.02392 15.5004C1.32013 12.4204 4.33029 10 8 10C11.6697 10 14.6799 12.4204 14.9761 15.5004Z"
          fill="#919191"
        />
      </g>
    </Icon>
  );
}
